import { createPortal } from "react-dom"

const portalRoot = document.getElementById("portal-root")

export default function Portal({ children }) {
    return createPortal(children, portalRoot)
}
